import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { PencilIcon, TrashIcon, PlusIcon } from '@heroicons/react/20/solid';

const KategoriContextMenu = ({ x, y, kategori, onClose, onDuzenle, onSil, onYeniEkle }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleYeniAltKategoriEkle = () => {
    onYeniEkle(null);
    onClose();
  };

  return createPortal(
    <div
      ref={menuRef}
      className="fixed z-50 min-w-[12rem] overflow-hidden rounded-xl border border-slate-200 bg-white py-1.5 text-sm shadow-xl"
      style={{ top: `${y}px`, left: `${x}px` }}
    >
      <ul>
        <li className="flex cursor-pointer items-center px-3 py-2 text-slate-700 transition-colors hover:bg-slate-50" onClick={() => { onDuzenle(kategori); onClose(); }}>
          <PencilIcon className="mr-2 h-4 w-4 text-slate-400" />
          <span>Düzenle</span>
        </li>
        <li className="flex cursor-pointer items-center px-3 py-2 text-slate-700 transition-colors hover:bg-slate-50" onClick={handleYeniAltKategoriEkle}>
          <PlusIcon className="mr-2 h-4 w-4 text-slate-400" />
          <span>Yeni Alt Kategori Ekle</span>
        </li>
        <li className="my-1 border-t border-slate-100" />
        <li className="flex cursor-pointer items-center px-3 py-2 text-rose-600 transition-colors hover:bg-rose-50" onClick={() => { onSil(kategori); onClose(); }}>
          <TrashIcon className="mr-2 h-4 w-4" />
          <span>Sil</span>
        </li>
      </ul>
    </div>,
    document.body
  );
};

export default KategoriContextMenu;
